<template>
  <main-content>
    <div class="col-12 col-lg-8">
      <profile-header />
      <TopStatistics />
      <live-status />
      <profile-now-playing />
      <profile-schedule />

      <!-- <div class="row" v-if="station_info.supports_requests || station_info.supports_streamers">
                <div class="col" v-if="station_info.supports_requests">
                    <profile-requests />
                </div>
                <div class="col" v-if="station_info.supports_streamers">
                    <profile-streamers/>
                </div>
      </div>-->
      <!-- <profile-public-pages/> -->

      <Map :data="$store.state.dashboard.listeners" />
    </div>

    <div class="col-lg-4">
      <profile-frontend />

      <ChartComponent
        title="Top 5 Countries"
        :chartdata="countries.data"
        :chartlabels="countries.labels"
        :key="countries.key"
      />

      <ChartComponent
        title="Top 5 Platforms"
        :chartdata="platforms.data"
        :chartlabels="platforms.labels"
        :key="platforms.key"
      />

      <ChartComponent
        :key="devices.key"
        title="Top 5 Devices"
        :chartdata="devices.data"
        :chartlabels="devices.labels"
      />

      <!-- <template v-if="true">
                <profile-frontend/>
      </template>-->

      <!-- //not available for free package -->
      <!-- <template v-if="true"> 
                <profile-backend/>
            </template>
            <template v-else>
                <profile-backend-none/>
      </template>-->

    </div>
  </main-content>
</template>


<script type="text/ecmascript-6">
import LiveStatus from "@/pages/dashboard/station_profile/LiveStatus";
import ChartComponent from "./components/ChartComponent.vue";
import TopStatistics from "./components/TopStatistics.vue";
import ProfileHeader from "@/pages/dashboard/station_profile/ProfileHeader";
import ProfileNowPlaying from "@/pages/dashboard/station_profile/ProfileNowPlaying";
import ProfileSchedule from "@/pages/dashboard/station_profile/ProfileSchedule";
import ProfileRequests from "@/pages/dashboard/station_profile/ProfileRequests";
import ProfileStreamers from "@/pages/dashboard/station_profile/ProfileStreamers";
import ProfilePublicPages from "@/pages/dashboard/station_profile/ProfilePublicPages";
import ProfileFrontend from "@/pages/dashboard/station_profile/ProfileFrontend";
import ProfileBackend from "@/pages/dashboard/station_profile/ProfileBackend";
import ProfileBackendNone from "@/pages/dashboard/station_profile/ProfileBackendNone";
import Map from "./components/DashboardMap.vue";

import { transformData } from "@/plugins/utils";

export default {
  components: {
    LiveStatus,
    ProfileHeader,
    ProfileNowPlaying,
    ProfileSchedule,
    ProfileRequests,
    ProfileStreamers,
    ProfilePublicPages,
    ProfileFrontend,
    ProfileBackend,
    ProfileBackendNone,
    ChartComponent,
    TopStatistics,
    Map
  },


  watch: {
    listener_info: {
      immediate: true,
      handler(value) {
        this.platforms = transformData(value, "platform");
        this.devices = transformData(value, "device");
        this.countries = transformData(value, "country");
      },
    }


  },


  data() {
    return {
      countries: {
        labels: [],
        data: [],
        key: "0",
      },
      platforms: {
        labels: [],
        data: [],
        key: "1",
      },
      devices: {
        labels: [],
        data: [],
        key: "2",
      },
    };
  },
};
</script>

<style scoped>
/* .table th,
.table td {
  border-top-style: none;
  padding: 0;
} */
</style>

